import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <div className="footer-container">      
      <div className="footer-border"></div>
      <footer className="footer">
        <div className="footer-content">
        </div>
      </footer>
    </div>
  );
};

export default Footer;
